import { inject, InjectionToken } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TabService, TabServiceTab } from "src/app/services/tab.service";
import { activatedRouteSnapshotGetPathFromRoot } from "src/app/support/activated-route";

export const CURRENT_TAB_FACTORY = new InjectionToken<
  () => TabServiceTab | undefined
>("current_tab_factory", {
  providedIn: "root",
  factory: () => {
    return () => {
      const activatedRoute = inject(ActivatedRoute);
      const url = activatedRouteSnapshotGetPathFromRoot(
        activatedRoute.snapshot
      );
      return inject(TabService).get(url);
    };
  }
});
